<button
  type="button"
  class="trieon-launcher"
  [class.trieon-launcher--active]="isOpen"
  (click)="toggleOpen()"
  aria-label="Toggle Trieon chat">
  <i class="pi" [class.pi-comments]="!isOpen" [class.pi-times]="isOpen"></i>
  <span>Trieon Bot</span>
</button>

<section class="trieon-panel" [class.trieon-panel--open]="isOpen" aria-live="polite">
  <header class="trieon-header">
    <div>
      <h3>Trieon Bot</h3>
      <p>Your HRIS assistant</p>
    </div>
    <button type="button" (click)="toggleOpen()" aria-label="Close chat">
      <i class="pi pi-times"></i>
    </button>
  </header>

  <div class="trieon-messages" #messageList>
    <article class="msg" *ngFor="let m of messages" [class.msg--user]="m.sender === 'user'">
      <div class="msg-bubble">{{ m.text }}</div>
    </article>

    <article class="msg" *ngIf="isTyping">
      <div class="msg-bubble msg-bubble--typing">
        <span></span><span></span><span></span>
      </div>
    </article>
  </div>

  <div class="trieon-prompts" *ngIf="messages.length <= 2 && !isTyping">
    <button type="button" *ngFor="let prompt of quickPrompts" (click)="sendQuickPrompt(prompt)">
      {{ prompt }}
    </button>
  </div>

  <footer class="trieon-input-row">
    <input
      type="text"
      [(ngModel)]="draft"
      placeholder="Ask Trieon..."
      (keydown.enter)="sendDraft()"
      [disabled]="isTyping" />
    <button type="button" (click)="sendDraft()" [disabled]="isTyping || !draft.trim()" aria-label="Send message">
      <i class="pi pi-send"></i>
    </button>
  </footer>
</section>
